/**
 * Created by itripp on 2/17/2016.
 */
/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class DocumentSignature implements Serializable<DocumentSignature> {
    id: number;
    x: number = 0;
    y: number = 0;
    w: number = 0;
    h: number = 0;
    templatePageNum: number;
    label: string;
    status: string;
    userId: number;
    dateAdded: boolean;
    addedBy: number;
    deleted: boolean = false;
    signatureLabel: string;
    type: string;
    pageNum: number;
    color: string;
    parentId: number;// group id of the objects
    roleId: number;
    value: string;
    quillValue: string;
    styles: {};
    validations: {};
    flags: {};
    visible;
    completedOn;
    placeholder: {};

    deserialize(input: any) {
        !!input.id && (this.id = input.id);
        !!input.type && (this.type = input.type);
        !!input.x && (this.x = input.x);
        !!input.y && (this.y = input.y);
        !!input.h && (this.h = input.h);
        !!input.w && (this.w = input.w);
        !!input.pageNum && (this.pageNum = input.pageNum);
        !!input.label && (this.label = input.label);
        !!input.status && (this.status = input.status);
        !!input.userId && (this.userId = input.userId);
        !!input.color && (this.color = input.color);
        !!input.parentId && (this.parentId = input.parentId);
        !!input.roleId && (this.roleId = input.roleId);
        if (input.userId == 0) {
            this.userId = undefined;
        }
        this.dateAdded = input.dateAdded ? input.dateAdded : false;
        this.addedBy = (input.addedBy) ? input.addedBy : 0;
        this.deleted = (input.deleted ? input.deleted : false);
        this.signatureLabel = (input.signatureLabel ? input.signatureLabel : '');
        this.value = (input.value ? input.value : '');
        this.quillValue = (input.quillValue ? input.quillValue : '');
        this.visible = true;
        this.flags = {};
        this.styles = {};
        this.validations = {};
        this.placeholder = {};
        if (input.completedOn) {
            try {
                this.completedOn = new Date(input.completedOn).getTime();
            } catch (e) {
                console.log("Improper date => ", input.completedOn);
            }
        }

        var addKeyValuesToObj = (stringData, object, valueType) => {
            var data = JSON.parse(stringData);
            if (valueType == "boolean") {
                for (var key in data) {
                    object[key] = (data[key].toLowerCase() == "true");
                }
            } else {
                for (var key in data) {
                    object[key] = data[key];
                }
            }
        };
        if (input.options && input.options.length > 0) {
            input.options.forEach(opt => {
                switch (opt.objectOptionType.toLowerCase()) {
                    case "style":
                        addKeyValuesToObj(opt.value, this.styles, "");
                        break;
                    case "validation":
                        addKeyValuesToObj(opt.value, this.validations, "");
                        break;
                    case "flag":
                        addKeyValuesToObj(opt.value, this.flags, "boolean");
                        break;
                    case "question":
                        addKeyValuesToObj(opt.value, this, "");
                        break;
                    case "placeholder":
                        addKeyValuesToObj(opt.value, this.placeholder, "");
                        break;
                    default:
                        this[opt.objectOptionType.toLowerCase()] = opt.value;
                        break;
                }
            });
        }
        if (input.jsonValues) {
            addKeyValuesToObj(input.jsonValues, this, "boolean");
        }
        return this;
    }

    getObject(id: number,
        type: string,
        x: number,
        y: number,
        w: number,
        h: number,
        pageNum: number,
        label: string,
        status: string,
        userId: number,
        dateAdded: boolean,
        parentId?) {
        this.id = id;
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
        this.pageNum = pageNum;
        this.type = type;
        this.label = label;
        this.status = status;
        this.userId = userId;
        this.dateAdded = dateAdded ? dateAdded : false;
        this.parentId = (parentId ? parentId : null);
        this.visible = true;
        return this;
    }
    constructor() {

    }
}
